export const transformWorkExperienceDetails = (data = {}) => ({
  candidate: {
    workExperience: {
      totalYrs: data.workExperienceYears || 0,
      workExMonths: data.workExperienceMonths || 0,
      currentRole: {
        designation: data.currentDesignation || '',
        orgName: data.currentOrganizationName || '',
        clientId: data.currentOrganizationId || '',
        startDate: data.currentRoleStartDate ? new Date(data.currentRoleStartDate) : null,
        endDate: null,
        industry: data.currentIndustrySector || '',
        industrySubcategory: data.currentIndustrySubCategory || '',
        function: data.currentFunction || "",
        functionSubcategory: data.currentFunctionSubCategory || "",

        location: data.currentLocation || '',
        // noticePeriod: data.currentNoticePeriod || '',
        noticePeriod: data.currentNoticePeriod === '' || data.currentNoticePeriod == null
          ? 0
          : Number(data.currentNoticePeriod),


        topThreeResponsibilities: Array.isArray(data.currenttop3Responsibilities)
          ? data.currenttop3Responsibilities.join(', ')
          : data.currenttop3Responsibilities || '',

        topThreeAchievements: Array.isArray(data.currenttop3Achievements)
          ? data.currenttop3Achievements.join(', ')
          : data.currenttop3Achievements || '',

        reportingTo: data.currentReportingTo || '',
        noOfReporters: data.currentNumberOfReportees || 0,
        teamSize: data.currentTeamSize || 0,
        hasPromotions: data.hasGotPromotions ? 'YES' : 'NO',
        promotions: data.careerPromotions?.map((promos) => ({
          previousDesignation: promos?.previousDesignation || '',
          promotionYr: promos?.promotionYear || null,
        })) || [],
      },
      previousJobs: data.previousJobs?.map((pj) => ({
        designation: pj?.designation || '',
        orgName: pj?.organizationName || '',
        clientId: pj?.clientId || null,
        startDate: pj?.roleStartDate ? new Date(pj.roleStartDate) : null,
        endDate: pj?.roleEndDate ? new Date(pj.roleEndDate) : null,
        industry: pj?.industrySector || '',
        industrySubcategory: pj?.subcategory || '',
        function: pj?.function || "",
        functionSubcategory: pj?.functionSubcategory || "",

        location: pj?.location || '',
        noticePeriod: 0,
        topThreeResponsibilities: Array.isArray(pj?.top3Responsibilities)
          ? pj.top3Responsibilities.join(', ')
          : pj.top3Responsibilities || '',

        topThreeAchievements: Array.isArray(pj?.top3Achievements)
          ? pj.top3Achievements.join(', ')
          : pj.top3Achievements || '',

        reportingTo: pj?.reportingTo || '',
        noOfReporters: pj?.numberOfReportees || 0,
        teamSize: pj?.teamSize || 0,
        hasPromotions: pj?.hasGotPromotions ? 'YES' : 'NO',
        promotions: pj?.careerPromotions?.map((pro) => ({
          previousDesignation: pro?.previousDesignation || '',
          promotionYr: pro?.promotionYear || null,
        })) || [],
      })) || [],
      awards: data.awards?.map((award) => ({
        ...award,
        issueYear: award?.issueYear || null,
      })) || [],
      hasCareerGaps: data.hasCareerGaps ? 'YES' : 'NO',
      careerGaps: data.careerGaps || [],
      techProficiencies: data.technicalProficiencies || [],
      professionalMemberships: data.professionalMemberships?.map((pm) => ({
        name: pm?.name || '',
        year: pm?.year || '',
      })) || [],
    },
  },
});

export const reverseTransformWorkExperienceDetails = (data = {}) => {
  if (!data) return {};

  const careerPromotions = data?.currentRole?.hasPromotions === 'YES'
    ? data.currentRole?.promotions?.map((promotion) => ({
      previousDesignation: promotion?.previousDesignation || '',
      promotionYear: promotion?.promotionYr || null,
    })) || []
    : [];

  const previousJobs = data.previousJobs?.map((job) => ({
    designation: job?.designation || '',
    organizationName: job?.orgName || '',
    clientId: job?.clientId || null,
    industrySector: job?.industry || '',
    subcategory: job?.industrySubcategory || '',
    function: job?.function || "",
    functionSubcategory: job?.functionSubcategory || "",

    location: job?.location || '',
    roleStartDate: job?.startDate ? new Date(job.startDate) : null,
    roleEndDate: job?.endDate ? new Date(job.endDate) : null,
    noticePeriod: job?.noticePeriod?.toString() || '',
    top3Responsibilities: job?.topThreeResponsibilities || '',
    top3Achievements: job?.topThreeAchievements || '',
    reportingTo: job?.reportingTo || '',
    numberOfReportees: job?.noOfReporters || 0,
    teamSize: job?.teamSize || 0,
    hasGotPromotions: job?.hasPromotions === 'YES',
    careerPromotions: job?.hasPromotions === 'YES' && job.promotions
      ? job.promotions.map((promotion) => ({
        previousDesignation: promotion?.previousDesignation || '',
        promotionYear: promotion?.promotionYr || null,
      })) || []
      : [],
  })) || [];

  const awards = data.awards || [];

  const hasCareerGaps = data.hasCareerGaps === 'YES';

  const careerGaps = hasCareerGaps
    ? data.careerGaps?.map((gap) => ({
      startDate: gap?.startDate ? new Date(gap.startDate) : null,
      endDate: gap?.endDate ? new Date(gap.endDate) : null,
      reasons: gap?.reasons || '',
    })) || []
    : [];

  const technicalProficiencies = data.techProficiencies?.map((proficiency) => ({
    skill: proficiency?.skill || '',
    rating: proficiency?.rating?.toString() || '',
    keyProject: proficiency?.keyProject || '',
  })) || [];

  const professionalMemberships = data.professionalMemberships?.map((membership) => ({
    name: membership?.name || '',
    year: membership?.year || '',
  })) || [];

  return {
    careerPromotions,
    previousJobs,
    workExperienceYears: Math.floor(data.totalYrs || 0),
    workExperienceMonths: data.workExMonths || 0,
    currentDesignation: data.currentRole?.designation || '',
    currentOrganizationName: data.currentRole?.orgName || '',
    currentOrganizationId: data.currentRole?.clientId || '',

    currentIndustrySector: data.currentRole?.industry || '',
    currentIndustrySubCategory: data.currentRole?.industrySubcategory || '',
    currentFunction: data.currentRole?.function || "",
    currentFunctionSubCategory: data.currentRole?.functionSubcategory || "",

    currentLocation: data.currentRole?.location || '',
    currentRoleStartDate: data.currentRole?.startDate ? new Date(data.currentRole.startDate) : null,
    currentNoticePeriod: data.currentRole?.noticePeriod?.toString() || '',
    currenttop3Responsibilities: data.currentRole?.topThreeResponsibilities || '',
    currenttop3Achievements: data.currentRole?.topThreeAchievements || '',
    currentReportingTo: data.currentRole?.reportingTo || '',
    currentNumberOfReportees: data.currentRole?.noOfReporters || 0,
    currentTeamSize: data.currentRole?.teamSize || 0,
    hasGotPromotions: data.currentRole?.hasPromotions === 'YES',
    awards,
    hasCareerGaps,
    careerGaps,
    technicalProficiencies,
    professionalMemberships,
  };
};
